import {
  createBrowserRouter,
  matchRoutes,
  useLocation,
} from 'react-router-dom'
import * as Sentry from '@sentry/react'
import {
  NotFound,
  Home,
  LoginPage,
  AuthPage,
  ProfilePage,
  TransactionPage,
  CompanyPage,
  PackageOverviewPage,
  PackageOverviewCreate,
  TelegramPage,
  CompanyCreate,
  TelegramCreate,
  CompanyUpdate,
  TelegramUpdate,
  RolePage,
  RoleCreate,
  RoleUpdate,
  UserPage,
  UserCreate,
  UserUpdate,
  ManagementSimPassportPage,
  ManagementTopUpPage,
  TransactionCreate,
  ManagementTopUpOrder,
  ManagementTopUpHistory,
  ManagementTopUpDetailTransaction,
  PackageAPIPage,
  PackageAPIOrder,
  PackageAPIHistory,
  PackageAPIDetailTransaction,
  PackageAPIDetailPackage,
  KitSimOrder,
  PackagePartnerPage,
  PackagePartnerCreate,
  KitSimConnect,
  RegisterAddonPage,
  RegisterAddonOrder,
  RegisterAddonHistory,
  RegisterAddonDetailTransaction,
  RegisterAddonDetailPackage,
  UserPartnerPage,
  UserPartnerCreate,
  UserPartnerUpdate,
  DashboardDauNoi,
  DashboardGiaHan,
  CompanyDetail,
  KitSimOverview,
  ConfigPage,
  KitSimRequest,
  TelesaleOverview,
  TelesaleCompany,
  TelesaleUser,
  KitOrderOrder,
  KitOrderDetail,
  KitOrderConnect,
  ExtensionCustomer,
  ExtensionCustomerDetail,
  ExtensionAgency,
  ExtensionAgencyDetail,
  ExtensionTelesale,
  SimExportOrder,
  SimExportOrderDetail,
  SimExportHistory,
  SimImportOrder,
  SimImportOrderDetail,
  SimImportHistory,
  InvoiceHistory,
  InvoiceCreate,
  CustomerHistory,
  ZaloAccounts,
  ZaloPermissions,
  ZaloConfig,
} from '../pages'
import {
  AUTH_LOGIN,
  HOME,
  PROFILE,
  COMPANY,
  PACKAGE,
  TRANSACTION,
  TELEGRAM,
  CREATE,
  UPDATE,
  ROLE,
  USER,
  SIM_PASSPORT,
  TOP_UP,
  DASHBOARD,
  ORDER,
  HISTORY,
  OVERVIEW,
  DETAIL_TRANSACTION,
  PACKAGE_API,
  DETAIL_PACKAGE,
  KIT_SIM,
  CUSTOMER,
  DETAIL,
  CONNECT,
  REGISTER_ADDON,
  USER_PARTNER,
  DAU_NOI,
  GIA_HAN,
  AGENCY,
  TELESALE,
  CONFIG,
  REQUEST,
  ADMIN,
  INVOICE,
  KIT_ORDER,
  EXTENSION,
  EXPORT,
  IMPORT,
  ZALO_ACCOUNT,
  ACCOUNTS,
  PERMISSIONS,
  ZALO_CONFIG,
} from '../assets/constants/route_path'
import Layout from '../layout'
import PrivateRoute from '../components/private-route'

export const routes = [
  {
    path: '/auth',
    element: <AuthPage />,
    children: [
      {
        path: AUTH_LOGIN,
        element: <LoginPage />,
      },
    ],
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: HOME,
        element: (
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        ),
      },
      {
        path: COMPANY,
        element: (
          <PrivateRoute>
            <CompanyPage />
          </PrivateRoute>
        ),
      },
      {
        path: COMPANY + CREATE,
        element: (
          <PrivateRoute>
            <CompanyCreate />
          </PrivateRoute>
        ),
      },
      {
        path: COMPANY + UPDATE,
        element: (
          <PrivateRoute>
            <CompanyUpdate />
          </PrivateRoute>
        ),
      },
      {
        path: COMPANY + DETAIL,
        element: (
          <PrivateRoute>
            <CompanyDetail />
          </PrivateRoute>
        ),
      },
      {
        path: PACKAGE + OVERVIEW,
        element: (
          <PrivateRoute>
            <PackageOverviewPage />
          </PrivateRoute>
        ),
      },
      {
        path: PACKAGE + OVERVIEW + CREATE,
        element: (
          <PrivateRoute>
            <PackageOverviewCreate />
          </PrivateRoute>
        ),
      },
      {
        path: PACKAGE + DETAIL,
        element: (
          <PrivateRoute>
            <PackagePartnerPage />
          </PrivateRoute>
        ),
      },
      {
        path: PACKAGE + DETAIL + CREATE,
        element: (
          <PrivateRoute>
            <PackagePartnerCreate />
          </PrivateRoute>
        ),
      },
      {
        path: TRANSACTION,
        element: (
          <PrivateRoute
          //     hasAnyFunctions={[PermUtils.canGetLisTransactionAdminResource]}
          >
            <TransactionPage />
          </PrivateRoute>
        ),
      },
      {
        path: TRANSACTION + CREATE,
        element: (
          <PrivateRoute>
            <TransactionCreate />
          </PrivateRoute>
        ),
      },
      {
        path: TELEGRAM,
        element: (
          <PrivateRoute>
            <TelegramPage />
          </PrivateRoute>
        ),
      },
      {
        path: TELEGRAM + CREATE,
        element: (
          <PrivateRoute>
            <TelegramCreate />
          </PrivateRoute>
        ),
      },
      {
        path: TELEGRAM + UPDATE,
        element: (
          <PrivateRoute>
            <TelegramUpdate />
          </PrivateRoute>
        ),
      },
      {
        path: PROFILE,
        element: (
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        )
      },
      {
        path: SIM_PASSPORT,
        element: (
          <PrivateRoute>
            <ManagementSimPassportPage />
          </PrivateRoute>
        )
      },
      {
        path: TOP_UP + OVERVIEW,
        element: (
          <PrivateRoute>
            <ManagementTopUpPage />
          </PrivateRoute>
        )
      },
      {
        path: TOP_UP + ORDER,
        element: (
          <PrivateRoute>
            <ManagementTopUpOrder />
          </PrivateRoute>
        )
      },
      {
        path: TOP_UP + HISTORY,
        element: (
          <PrivateRoute>
            <ManagementTopUpHistory />
          </PrivateRoute>
        )
      },
      {
        path: TOP_UP + DETAIL_TRANSACTION,
        element: (
          <PrivateRoute>
            <ManagementTopUpDetailTransaction />
          </PrivateRoute>
        )
      },
      {
        path: PACKAGE_API + OVERVIEW,
        element: (
          <PrivateRoute>
            <PackageAPIPage />
          </PrivateRoute>
        )
      },
      {
        path: PACKAGE_API + ORDER,
        element: (
          <PrivateRoute>
            <PackageAPIOrder />
          </PrivateRoute>
        )
      },
      {
        path: PACKAGE_API + HISTORY,
        element: (
          <PrivateRoute>
            <PackageAPIHistory />
          </PrivateRoute>
        )
      },
      {
        path: PACKAGE_API + DETAIL_TRANSACTION,
        element: (
          <PrivateRoute>
            <PackageAPIDetailTransaction />
          </PrivateRoute>
        )
      },
      {
        path: PACKAGE_API + DETAIL_PACKAGE,
        element: (
          <PrivateRoute>
            <PackageAPIDetailPackage />
          </PrivateRoute>
        )
      },
      {
        path: REGISTER_ADDON + OVERVIEW,
        element: (
          <PrivateRoute>
            <RegisterAddonPage />
          </PrivateRoute>
        )
      },
      {
        path: REGISTER_ADDON + ORDER,
        element: (
          <PrivateRoute>
            <RegisterAddonOrder />
          </PrivateRoute>
        )
      },
      {
        path: REGISTER_ADDON + HISTORY,
        element: (
          <PrivateRoute>
            <RegisterAddonHistory />
          </PrivateRoute>
        )
      },
      {
        path: REGISTER_ADDON + DETAIL_TRANSACTION,
        element: (
          <PrivateRoute>
            <RegisterAddonDetailTransaction />
          </PrivateRoute>
        )
      },
      {
        path: REGISTER_ADDON + DETAIL_PACKAGE,
        element: (
          <PrivateRoute>
            <RegisterAddonDetailPackage />
          </PrivateRoute>
        )
      },
      {
        path: KIT_SIM + OVERVIEW,
        element: (
          <PrivateRoute>
            <KitSimOverview />
          </PrivateRoute>
        )
      },
      {
        path: KIT_SIM + CONNECT,
        element: (
          <PrivateRoute>
            <KitSimConnect />
          </PrivateRoute>
        )
      },
      {
        path: KIT_SIM + REQUEST,
        element: (
          <PrivateRoute>
            <KitSimRequest />
          </PrivateRoute>
        )
      },
      {
        path: KIT_SIM + ORDER,
        element: (
          <PrivateRoute>
            <KitSimOrder />
          </PrivateRoute>
        )
      },
      {
        path: KIT_ORDER + CONNECT,
        element: (
          <PrivateRoute>
            <KitOrderConnect />
          </PrivateRoute>
        )
      },
      {
        path: KIT_ORDER + ORDER,
        element: (
          <PrivateRoute>
            <KitOrderOrder />
          </PrivateRoute>
        )
      },
      {
        path: KIT_ORDER + ORDER + DETAIL,
        element: (
          <PrivateRoute>
            <KitOrderDetail />
          </PrivateRoute>
        )
      },
      {
        path: INVOICE + CREATE,
        element: (
          <PrivateRoute>
            <InvoiceCreate />
          </PrivateRoute>
        )
      },
      {
        path: INVOICE + HISTORY,
        element: (
          <PrivateRoute>
            <InvoiceHistory />
          </PrivateRoute>
        )
      },
      {
        path: EXTENSION + CUSTOMER,
        element: (
          <PrivateRoute>
            <ExtensionCustomer />
          </PrivateRoute>
        )
      },
      {
        path: EXTENSION + CUSTOMER + DETAIL,
        element: (
          <PrivateRoute>
            <ExtensionCustomerDetail />
          </PrivateRoute>
        )
      },
      {
        path: EXTENSION + AGENCY,
        element: (
          <PrivateRoute>
            <ExtensionAgency />
          </PrivateRoute>
        )
      },
      {
        path: EXTENSION + AGENCY + DETAIL,
        element: (
          <PrivateRoute>
            <ExtensionAgencyDetail />
          </PrivateRoute>
        )
      },
      {
        path: EXTENSION + TELESALE,
        element: (
          <PrivateRoute>
            <ExtensionTelesale />
          </PrivateRoute>
        )
      },
      {
        path: IMPORT + ORDER,
        element: (
          <PrivateRoute>
            <SimImportOrder />
          </PrivateRoute>
        )
      },
      {
        path: IMPORT + ORDER + DETAIL,
        element: (
          <PrivateRoute>
            <SimImportOrderDetail />
          </PrivateRoute>
        )
      },
      {
        path: IMPORT + HISTORY,
        element: (
          <PrivateRoute>
            <SimImportHistory />
          </PrivateRoute>
        )
      },
      {
        path: EXPORT + ORDER,
        element: (
          <PrivateRoute>
            <SimExportOrder />
          </PrivateRoute>
        )
      },
      {
        path: EXPORT + ORDER + DETAIL,
        element: (
          <PrivateRoute>
            <SimExportOrderDetail />
          </PrivateRoute>
        )
      },
      {
        path: EXPORT + HISTORY,
        element: (
          <PrivateRoute>
            <SimExportHistory />
          </PrivateRoute>
        )
      },
      {
        path: COMPANY + USER_PARTNER,
        element: (
          <PrivateRoute>
            <UserPartnerPage />
          </PrivateRoute>
        ),
      },
      {
        path: COMPANY + USER_PARTNER + CREATE,
        element: (
          <PrivateRoute>
            <UserPartnerCreate />
          </PrivateRoute>
        ),
      },
      {
        path: COMPANY + USER_PARTNER + UPDATE,
        element: (
          <PrivateRoute>
            <UserPartnerUpdate />
          </PrivateRoute>
        ),
      },
      {
        path: CUSTOMER + HISTORY,
        element: (
          <PrivateRoute>
            <CustomerHistory />
          </PrivateRoute>
        ),
      },
      {
        path: DASHBOARD + DAU_NOI,
        element: (
          <PrivateRoute>
            <DashboardDauNoi />
          </PrivateRoute>
        )
      },
      {
        path: DASHBOARD + GIA_HAN,
        element: (
          <PrivateRoute>
            <DashboardGiaHan />
          </PrivateRoute>
        )
      },
      {
        path: TELESALE + OVERVIEW,
        element: (
          <PrivateRoute>
            <TelesaleOverview />
          </PrivateRoute>
        )
      },
      {
        path: TELESALE + COMPANY,
        element: (
          <PrivateRoute>
            <TelesaleCompany />
          </PrivateRoute>
        )
      },
      {
        path: TELESALE + USER,
        element: (
          <PrivateRoute>
            <TelesaleUser />
          </PrivateRoute>
        )
      },
      {
        path: ZALO_ACCOUNT + ACCOUNTS,
        element: (
          <PrivateRoute>
            <ZaloAccounts />
          </PrivateRoute>
        )
      },
      {
        path: ZALO_ACCOUNT + PERMISSIONS,
        element: (
          <PrivateRoute>
            <ZaloPermissions />
          </PrivateRoute>
        )
      },
      {
        path: ZALO_ACCOUNT + ZALO_CONFIG,
        element: (
          <PrivateRoute>
            <ZaloConfig />
          </PrivateRoute>
        )
      },
      {
        path: ADMIN + USER,
        element: (
          <PrivateRoute>
            <UserPage />
          </PrivateRoute>
        ),
      },
      {
        path: ADMIN + USER + CREATE,
        element: (
          <PrivateRoute>
            <UserCreate />
          </PrivateRoute>
        ),
      },
      {
        path: ADMIN + USER + UPDATE,
        element: (
          <PrivateRoute>
            <UserUpdate />
          </PrivateRoute>
        ),
      },
      {
        path: ADMIN + ROLE,
        element: (
          <PrivateRoute>
            <RolePage />
          </PrivateRoute>
        ),
      },
      {
        path: ADMIN + ROLE + CREATE,
        element: (
          <PrivateRoute>
            <RoleCreate />
          </PrivateRoute>
        ),
      },
      {
        path: ADMIN + ROLE + UPDATE,
        element: (
          <PrivateRoute>
            <RoleUpdate />
          </PrivateRoute>
        ),
      },
      {
        path: ADMIN + CONFIG,
        element: (
          <PrivateRoute>
            <ConfigPage />
          </PrivateRoute>
        )
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]

export const useMatchedRoute = () => {
  const location = useLocation()
  const matchedRoutes = matchRoutes(routes, location)

  if (!matchedRoutes || matchedRoutes.length === 0) {
    return undefined
  }

  // Sort by accuracy desc
  matchedRoutes.reverse()

  for (let matchedRoute of matchedRoutes) {
    const matchedRoutePath = matchedRoute.route.path
    // index route will not contain path attr -> get next route (parent route)
    if (matchedRoutePath) {
      return matchedRoutePath
    }
  }

  return undefined
}

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter)
export const router = sentryCreateBrowserRouter(routes)
